// @flow
import * as React from 'react'

import './H4.scss'

type Props = {
  children: React.Node,
}

export default class H4 extends React.Component<Props> {
  render = () => {
    return <div className="H4">{this.props.children}</div>
  }
}
